import React, { useEffect, useState, useRef } from "react";
import GridHeader from "./GridHeader";
import GridItem from "./GridItem";
import { Pagination } from "@material-ui/lab";
import { Grid, makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DMSelect from "../DMSelect";
import { orderBy } from "lodash";
import { constants } from "../../../../constants/constants";
import { injectIntlTranslation } from "@carrier-ecat/workflowui-globalfunctions";
import { injectIntl } from "react-intl";

const DMGrid = (props) => {
  const useStyles = makeStyles((theme) => ({
    noDataFound: {
      fontSize: "20px",
      display: "flex",
      justifyContent: "center",
      padding: "40px 0",
      cursor: "pointer",
      width: "100%",
    },
  }));

  const { intl } = props;

  const classes = useStyles();
  const dragRef = useRef();

  const [sortCol, setSortCol] = useState("");
  const [sortKey, setSortKey] = useState("");
  const [sortType, setSortType] = useState("");

  const [unSortedData, setUnSortedData] = useState([]);

  useEffect(() => {
    if (props?.data?.length) {
      setUnSortedData(props.data);
    }
  }, [props.data]);

  const reorderFunc = (arr, removeIndex, addIndex) => {
    if (!arr) return;
    const [reorderedFields] = arr.splice(removeIndex, 1);
    arr.splice(addIndex, 0, reorderedFields);
    return arr;
  };

  const handleDrop = (droppedItem) => {
    if (
      !droppedItem.destination ||
      droppedItem.destination.index === droppedItem.source.index
    ) {
      return;
    }
    const oldFields = [...data];
    const updatedFields = reorderFunc(
      oldFields,
      droppedItem.source.index,
      droppedItem.destination.index
    );
    if (props?.onUpdate) {
      props.onUpdate(updatedFields);
    }
    if (props.tab === "views" && props?.onDrag) {
      props.onDrag(updatedFields);
    } else if (props?.onDrag) {
      const sourceIndex = droppedItem.source.index;
      const destinationIndex = droppedItem.destination.index;
      if (sourceIndex < destinationIndex) {
        const mutatedArray = updatedFields.slice(
          sourceIndex,
          destinationIndex + 1
        );
        const secondLastItemSortNumber =
          mutatedArray[mutatedArray.length - 2]?.sort;
        const itemsWithUpdatedSortNumber = mutatedArray.map((item, index) => {
          if (index === mutatedArray.length - 1) {
            item.sort = secondLastItemSortNumber;
            return item;
          }

          item.sort -= 1;
          return item;
        });
        props.onDrag(itemsWithUpdatedSortNumber);
      }
      if (sourceIndex > destinationIndex) {
        const mutatedArray = updatedFields.slice(
          destinationIndex,
          sourceIndex + 1
        );
        const secondItemSortNumber = mutatedArray[1]?.sort;
        const itemsWithUpdatedSortNumber = mutatedArray.map((item, index) => {
          if (index === 0) {
            item.sort = secondItemSortNumber;
            return item;
          }

          item.sort += 1;
          return item;
        });
        props.onDrag(itemsWithUpdatedSortNumber);
      }
    }
    setData(updatedFields);
  };

  const pageLimit = 10;

  const [data, setData] = useState(props.data);
  const [loading, setLoading] = useState(props.loading);
  const [pagination, setPagination] = useState({
    limit: pageLimit,
    offset: props.selectedPage,
  });

  // const showCurrentPageData = (arr, i, chunkSize) => {
  //   i = i - 1;
  //   const index = i > 0 ? chunkSize * i : 0;
  //   let currentPage = `${index + 1} - ${index + chunkSize}`;
  //   if (index + chunkSize > arr.length) {
  //     currentPage = `${index + 1} - ${arr.length}`;
  //   }
  //   return currentPage;
  // };

  // const sliceIntoChunks = (arr, i, chunkSize) => {
  //   i = i - 1;
  //   const index = i > 0 ? chunkSize * i : 0;
  //   const chunk = arr.slice(index, index + chunkSize);
  //   return chunk;
  // };

  const showCurrentPageData = (arr, i, chunkSize) => {
    if (props?.disablePagination) return `1 - ${arr.length}`;
    i = i - 1;
    const index = i > 0 ? chunkSize * i : 0;
    let currentPage = `${index + 1} - ${index + chunkSize}`;
    if (index + chunkSize > arr.length) {
      currentPage = `${index + 1} - ${arr.length}`;
    }
    return currentPage;
  };

  const sliceIntoChunks = (arr, i, chunkSize) => {
    if (props?.disablePagination) return arr;
    i = i - 1;
    const index = i > 0 ? chunkSize * i : 0;
    const chunk = arr.slice(index, index + chunkSize);
    return chunk;
  };

  const handlePagination = (limit, offset) => {
    setPagination({ limit, offset });
  };

  const handleDummy = (e, offset) => {
    handlePagination(pagination.limit, offset);
    setPagination((prevState) => ({
      ...prevState,
      offset,
    }));
    props.onPageSelection(offset);
  };

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  useEffect(() => {
    setData(props.data.sort((a, b) => a?.sort - b?.sort));
    setPagination({
      limit: pagination.limit,
      offset: props.selectedPage,
    });

    if (sortType && sortKey) sortAcs(props.data, sortType, sortKey);
  }, [props.data, props.selectedPage, props?.pageSize]);

  // useEffect(() => {
  //   if (props?.onPageSelection) props.onPageSelection(1);
  // }, [props.data]);

  const handlePageSizeChange = (value) => {
    setPagination({
      limit: value,
      offset: 1,
    });
    if(props.tab !== "views") {
      props.onPageSelection(1);
    }
  };

  const sortAcs = (arr, sortType, sortKey) => {
    if (sortType && sortKey && props.data?.length) {
      let temp = orderBy(
        arr,
        [(sortKeydata) => sortKeydata[sortKey]?.toString()?.toLowerCase()],
        [sortType]
      );
      setData(temp);
    } else {
      setData([...props.data]);
    }
  };

  const handleSorting = (col, key = null) => {
    let type = "";
    let tempCol = "";
    if (col === sortCol && key) {
      if (sortType === "" || sortType === "desc") {
        type = "asc";
      } else if (sortType === "asc") {
        type = "desc";
      }
      tempCol = col;
    } else {
      type = "asc";
      tempCol = col;
    }
    setSortCol(tempCol);
    setSortKey(key);
    setSortType(type);
  };

  useEffect(() => {
    if (sortCol && sortKey) {
      sortAcs(props.data, sortType, sortKey);
    }
  }, [sortType, sortCol, sortKey]);

  return (
    <>
      <Grid
        container
        alignItems="center"
        justify="space-between"
        style={{ marginBottom: "16px" }}
      >
        {props?.tableHead ? (
          <Grid item style={{ width: "100%" }}>
            <div
              style={{
                borderBottom: "1px solid rgb(208 208 208)",
                borderTop: "none",
                lineHeight: "30px",
                display: "flex",
                padding: "4px 10px",
              }}
            >
              <div style={{ flex: "1" }}>{props?.tableHead}</div>
              {data?.length > 0 && (
                <b>{`${injectIntlTranslation(
                  intl,
                  "showingTableLabel",
                  constants.showingTableLabel
                )} ${showCurrentPageData(
                  data,
                  pagination.offset,
                  pagination.limit
                )} of ${data.length}`}</b>
              )}
            </div>
          </Grid>
        ) : (
          <Grid item>
            {data?.length > 0 && (
              <b>{`${injectIntlTranslation(
                intl,
                "showingTableLabel",
                constants.showingTableLabel
              )} ${showCurrentPageData(
                data,
                pagination.offset,
                pagination.limit
              )} of ${data.length}`}</b>
            )}
          </Grid>
        )}
        <Grid item style={{ display: "flex" }}>
          {!props.disablePagination && data.length > pagination.limit && (
            <Pagination
              variant="outlined"
              shape="rounded"
              page={pagination.offset}
              onChange={handleDummy}
              count={Math.ceil(data.length / pagination.limit)}
            />
          )}

          {!props.disablePagination && props?.pageSize && (
            <div style={{ display: "block" }}>
              {/* <div
                style={{
                  fontSize: "12px",
                  paddingLeft: "20px",
                  marginTop: "-13px",
                }}
              >
                {injectIntlTranslation(intl, "pageSize" , constants.pageSize)}
              </div> */}
              <div
                style={{
                  marginLeft: "20px",
                  width: "fit-content",
                  padding: "0 0 0 10px",
                }}
              >
                <DMSelect
                  id="sort-by-select"
                  label={injectIntlTranslation(
                    intl,
                    "pageSize",
                    constants.pageSize
                  )}
                  defaultValue={10}
                  lists={[
                    { label: "10", value: 10 },
                    { label: "50", value: 50 },
                    { label: "100", value: 100 },
                    {
                      label: injectIntlTranslation(
                        intl,
                        "View All",
                        "View All"
                      ),
                      value: props?.pageSize,
                    },
                  ]}
                  onChange={handlePageSizeChange}
                  styles={{ width: "150px" }}
                />
              </div>
            </div>
          )}
        </Grid>
      </Grid>
      <GridHeader
        items={props.headers}
        className={props.headerClassName}
        handleSorting={handleSorting}
        sortType={sortType}
        sortCol={sortCol}
      />
      {loading && (
        <Grid
          container
          alignItems="center"
          justify="center"
          alignContent="center"
        >
          <CircularProgress />
        </Grid>
      )}
      {props?.data?.length === 0 && (
        <div className={classes.noDataFound}>NO DATA FOUND</div>
      )}
      {!!props?.draggable && props?.data?.length !== 0 && (
        <div ref={dragRef} style={{ width: "100%" }}>
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId={`views-draggable-array`}>
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  {...provided.dragHandleProps}
                  ref={provided.innerRef}
                >
                  {sliceIntoChunks(
                    data,
                    pagination.offset,
                    pagination.limit
                  ).map((row, index) => {
                    return (
                      <Draggable
                        id={row?.rowId || row?.rowKey}
                        key={row?.rowId || row?.rowKey}
                        draggableId={`${row?.rowId || row?.rowKey}`}
                        index={index}
                      >
                        {(provided2) => (
                          <div
                            id={row?.rowId || row?.rowKey}
                            key={row?.rowId || row?.rowKey}
                            {...provided2.draggableProps}
                            {...provided2.dragHandleProps}
                            ref={provided2.innerRef}
                          >
                            <GridItem
                              key={row?.rowId || row?.rowKey}
                              highlight={row.highlight}
                              items={row.rowValue}
                              className={props.headerClassName}
                            />
                          </div>
                        )}
                      </Draggable>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      )}
      {!props?.draggable &&
        props?.data?.length !== 0 &&
        sliceIntoChunks(data, pagination.offset, pagination.limit).map(
          (row) => {
            return (
              <GridItem
                key={row.rowKey}
                highlight={row.highlight}
                items={row.rowValue}
                className={props.headerClassName}
              />
            );
          }
        )}
    </>
  );
};

export default injectIntl(DMGrid);
